import React, { useState, useEffect } from 'react';
import { Progress } from 'antd';
import { useGlobal } from '../GlobalContext/GlobalContext';

const LoadingOverlay = () => {
  const { loading } = useGlobal();
  const [percent, setPercent] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let intervalId;
    let timeoutId;

    if (loading) {
      setVisible(true);
      setPercent(0);

      intervalId = setInterval(() => {
        setPercent(prev => {
          if (prev >= 90) {
            clearInterval(intervalId);
            return 90;
          }
          return prev + (90 - prev) * 0.1;
        });
      }, 100);
    } else {
      setPercent(100);

      timeoutId = setTimeout(() => {
        setVisible(false);
        setPercent(0);
      }, 500);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [loading]);

  if (!visible) return null;

  const containerStyle = {
    position: 'fixed',
    top: '-16px',
    insetInlineStart: 0,
    width: '100%',
    height: '2px',
    zIndex: 9999,
  };

  return (
    <div style={containerStyle}>
      <Progress
        percent={percent}
        showInfo={false}
        strokeColor={{
          '0%': '#1890ff',
          '100%': '#001529'
        }}
        strokeWidth={4}
      />
    </div>
  );
};

export default LoadingOverlay;
